import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelTransfer: {
    id: 'sentinel.components.reopenTransferForm.cancelTransfer',
    defaultMessage: 'Cancel Transfer',
  },
  commentSubTitle: {
    id: 'sentinel.components.reopenTransferForm.commentSubTitle',
    defaultMessage: 'Comment (optional)',
  },
  cancelBtn: {
    id: 'sentinel.components.reopenTransferForm.cancelBtn',
    defaultMessage: 'Cancel Transfer',
  },
  closeBtn: {
    id: 'sentinel.components.reopenTransferForm.closeBtn',
    defaultMessage: 'Close',
  },
  submit: {
    id: 'sentinel.components.reopenTransferForm.submit',
    defaultMessage: 'submit',
  },
});



// WEBPACK FOOTER //
// ./src/components/CancelTransferForm/messages.js